module.exports = __webpack_public_path__ + "img/vertical_6_4_7005.d4f46391.png";